import type { GetVacationProductListParam } from '~/services/model/product/line-list';
import { consola } from 'consola';
import { REQUEST_CODES } from "~/constants/const-http";
import { MaybeRefOrGetter, toValue, useAsyncState } from "@vueuse/core";
import { getProductList } from "@/services/vacation";
import { toNumber } from '~/utils/helpers';
import { useRouteQuery } from '@/composables/router';

export function useVacationProductList(
  param: MaybeRefOrGetter<GetVacationProductListParam> = {}
) {
  const pageIndex = useRouteQuery('page_index', '1', {
    transform: toNumber
  });
  const { state, execute, isLoading } = useAsyncState(
    async () => {
      const { code, data, msg } = await getProductList(toValue(param));
      if (code !== REQUEST_CODES.ERROR_OK) {
        throw new Error(msg);
      }
      return data;
    },
    {
      page_index: 1,
      page_size: 10,
      total_page: 1,
      total_count: 1,
      page_count: 1,
      list: [],
    },
    {
      immediate: false,
      resetOnExecute: false,
      onError: err => consola.error('useVacationProductList', err),
      onSuccess: res => consola.log('useVacationProductList', res)
    }
  );


  const onPageChange = (page: number) => {
    pageIndex.value = page;
    execute(0);
  }


  return {
    state,
    execute,
    isLoading,
    pageIndex,
    onPageChange
  }
}
